/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Menu, Dropdown } from "antd";
import { connect } from "react-redux";
import { LogoutOutlined, UserOutlined, ClearOutlined } from "@ant-design/icons";
import Icon from "components/util-components/Icon";
import { signOut } from "redux/actions/Auth";
import requestCacheService from "services/RequestCacheService";

const menuItem = [];

export const NavProfile = ({ signOut, user }) => {
	const profileMenuItems = [
		...menuItem.map((el, i) => ({
			key: `item-${i}`,
			icon: <Icon className="mr-3" type={el.icon} />,
			label: (
				<a href={el.path}>
					<span className="font-weight-normal">{el.title}</span>
				</a>
			),
		})),
		{
			key: "cache",
			icon: <ClearOutlined className="mr-3" />,
			label: (
				<span className="font-weight-normal">Limpar cache</span>
			),
			onClick: () => requestCacheService.limparCache(),
		},
		{
			key: "logout",
			icon: <LogoutOutlined className="mr-3" />,
			label: <span className="font-weight-normal">Sair</span>,
			onClick: () => signOut(),
		},
	];

	const profileMenu = (
		<div className="nav-profile nav-dropdown">
			<div className="nav-profile-header">
				<div className="d-flex">
					<UserOutlined style={{ fontSize: 45 }} />
					<div className="pl-3">
						<h4 className="mb-0">{user.name}</h4>
						<span className="text-muted">{user.role}</span>
					</div>
				</div>
			</div>
			<div className="nav-profile-body">
				<Menu items={profileMenuItems} />
			</div>
		</div>
	);

	return (
		<Dropdown
			placement="bottomRight"
			overlay={profileMenu}
			trigger={["click"]}
		>
			<span
				className="d-flex align-item-center nav-profile-trigger"
				style={{ cursor: "pointer" }}
				aria-hidden="true"
			>
				<UserOutlined className="nav-icon mr-0" />
			</span>
		</Dropdown>
	);
};

const mapStateToProps = ({ user }) => {
	return { user: { ...user } };
};

export default connect(mapStateToProps, { signOut })(NavProfile);
